import type { IconSvgObject } from './types';

const PhoneOff01Icon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 18.5V20C18.5 21.1046 17.6046 22 16.5 22H7.5C6.39543 22 5.5 21.1046 5.5 20V5.5M6.35793 2.35793C6.68173 2.1323 7.07542 2 7.5 2H16.5C17.6046 2 18.5 2.89543 18.5 4V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 2H10L10.5 3H13.5L14 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PhoneOff01Icon;
